@if (showOfflineScreen() && !purchase()) {
  <app-payments-offline
    [cause]="disabledCause()"
    [showBack]="data.source === 'wallet'"
    (close)="close()"
    (back)="backToWallet()"
  />
} @else if (purchase()) {
  @if (purchase()!.blockchain_id) {
    <app-crypto-confirm-purchase
      [purchase]="purchase()!"
      (close)="close()"
    />
  } @else {
    <app-card-confirm-purchase
      [purchase]="purchase()!"
      [package]="purchaseSelection()!"
      (close)="close($event)"
    />
  }
} @else {
  @switch(view()) {
    @case ('buy-coins') {
      <app-buy-coins
        [noSCInitialView]="!!data.noSCInitialView"
        [fiatPurchaseEnabled]="!!fiatPurchaseEnabled()"
        [cryptoPurchaseEnabled]="!!cryptoPurchaseEnabled()"
        [initialAmount]="purchaseSelection()?.inputAmount?.toNumber() ?? null"
        [purchaseLimitReached]="purchaseLimitReached()"
        (selectPackage)="selectPurchaseWithMethod($event)"
        (close)="close()"
      />
    }
    @case ('purchase-payment-method') {
      <app-purchase-payment-method
        [package]="purchaseSelection()!"
        [paymentMethod]="selectedPaymentMethod()!"
        (close)="close($event)"
        (back)="view.set('buy-coins')"
        (purchaseLimitReached)="handlePurchaseLimitReached()"
      />
    }
    @case ('card-purchase') {
      <app-card-purchase
        [purchaseSelection]="purchaseSelection()!"
        [preselectedSavedCard]="selectedSavedCard()"
        (close)="close($event)"
        (back)="view.set('buy-coins')"
        (purchaseLimitReached)="handlePurchaseLimitReached()"
      />
    }
    @case ('crypto-purchase') {
      <app-crypto-purchase
        [package]="purchaseSelection()!"
        (close)="close()"
        (back)="view.set('buy-coins')"
        (purchaseLimitReached)="handlePurchaseLimitReached()"
      />
    }
    @case ('kyc') {
      <app-kyc-purchase
        [package]="purchaseSelection()!"
        (close)="close()"
        (back)="view.set('buy-coins')"
        (continue)="handleKycContinue()"
      />
    }
  }
}
